import { ROUTES } from '@/constants/routes'

export const serviceOffers = {
  threeMonthPackage: {
    id: 'three-month-programme',
    title: '3-Month Package',
    category: 'Ongoing support',
    price: '£1,200',
    priceNote: 'Total for the full 3-month programme',
    description:
      'A personalised 12-week health programme with regular one-to-one reviews and guidance that develops with you.',
    path: ROUTES.WORK_WITH_ME,
  },
  integratedConsult: {
    id: 'integrated-health',
    title: 'Integrated Health Consult and Scan',
    category: 'Consultation & scan',
    price: '£270',
    priceNote: 'Consultation, Bio-Scan, reports & follow-up',
    description:
      'An in-depth consultation and Bio-Scan, brought together in a personalised Integrated Health Report with a follow-up Zoom session.',
    path: ROUTES.SERVICES_INTEGRATED_HEALTH,
  },
  holisticScan: {
    id: 'holistic-health-scan',
    title: 'Holistic Health Scan',
    category: 'Wellness assessment',
    price: '£150',
    priceNote: 'Holistic Health Scan',
    description:
      'Enquire about a Holistic Health Scan. Kandake can explain what the appointment involves and help you decide whether it suits your needs.',
    path: ROUTES.SERVICES_SCANS,
  },
  bioScan: {
    id: 'bio-scan',
    title: 'Bio-Scan',
    category: 'Wellness assessment',
    price: '£150',
    priceNote: 'Scan, report & personal feedback',
    description:
      'A non-invasive wellness assessment with a detailed report, one-to-one feedback and a personal health summary with practical first steps.',
    path: ROUTES.SERVICES_SCANS,
  },
} as const

export type ServiceOffer = (typeof serviceOffers)[keyof typeof serviceOffers]

export const getServiceEnquiryPath = (offer: ServiceOffer) =>
  `${ROUTES.CONTACT}?service=${offer.id}`
